import React from "react";
import { SliceComponentProps } from "@prismicio/react";

import { AVAILABLE_LANGS } from "@typings/globals";

import { Tabs } from "@components/DataDisplay/Tabs";

import { PrismicLandingPageV2DataBodyCostBreakdown } from "@www/graphql-types";

import { Section } from "../../Components/Section";

import { CostTableData } from "./CostBreakdown.types";
import { transformData } from "./CostBreakdown.helpers";
import { Table } from "./Table";

export const CostBreakdown = (
  props: SliceComponentProps<
    PrismicLandingPageV2DataBodyCostBreakdown,
    {
      language: AVAILABLE_LANGS;
      costTableData: CostTableData | null;
    }
  >,
): React.ReactElement | null => {
  const costTableData = transformData(props.context.costTableData);

  if (!costTableData) {
    return null;
  }

  return (
    <Section
      heading={props.slice.primary.cost_breakdown_title.text || ""}
      description={
        props.slice.primary.cost_breakdown_description.text || undefined
      }
      bgColor={props.slice.primary.cost_breakdown_background || "transparent"}
      isDarkMode={!!props.slice.primary.cost_breakdown_color_mode}
    >
      <Tabs.Container
        animation="opacity"
        isDarkMode={!!props.slice.primary.cost_breakdown_color_mode}
      >
        {costTableData.map(({ id, label, headers, groups }) => (
          <Tabs.Element key={id} data-asd={id} id={id} buttonLabel={label}>
            <Table.Root headerLabels={headers}>
              {groups.map(({ headers, rows }, index) => (
                <Table.TBody key={index} headerLabels={headers}>
                  {rows.map((row, index) => (
                    <Table.Row key={index} {...row} />
                  ))}
                </Table.TBody>
              ))}
            </Table.Root>
          </Tabs.Element>
        ))}
      </Tabs.Container>
    </Section>
  );
};
